// @flow
import * as React from "react"
import { stopPropagation } from "common/events"
import { OverlayWrapperWrap, Overlay, Content } from "./styled"

type Props = {|
  isOpen: boolean,
  onClose: Function,
  children: React.Node,
|}

const handleClick = fn => event => {
  event.preventDefault()
  fn(event)
}

const OverlayWrapper = ({ isOpen, onClose, children }: Props) => (
  <OverlayWrapperWrap onClick={stopPropagation} isOpen={isOpen}>
    <Overlay open={isOpen} onClick={handleClick(onClose)} />
    <Content>{children}</Content>
  </OverlayWrapperWrap>
)

export default OverlayWrapper



// WEBPACK FOOTER //
// ./src/pages/_Page/MainNav/Hamburger/OverlayWrapper/index.js